import { useEffect, useState } from 'react';
export function useAdImageDimensions(adRef, adHasLoaded) {
    const [imageHeight, setImageHeight] = useState(undefined);
    useEffect(() => {
        if (adRef.current && adHasLoaded) {
            const iframe = adRef.current.querySelector('iframe');
            if (iframe) {
                const img = iframe.contentDocument?.querySelector('img');
                if (img) {
                    const imgWidth = img.getAttribute('width');
                    const imgHeight = img.getAttribute('height');
                    if (imgWidth && imgHeight) {
                        setImageHeight(parseFloat(imgHeight));
                    }
                }
            }
        }
    }, [adHasLoaded, adRef]);
    return imageHeight;
}
